import * as resolvers from 'app/infrastructure/ui/renderer/resolvers';
import { ComplexValue, ValueProperty } from 'ui';

export const integrityValues = (caseState, uiEngineProps) => ({
  integrityStatus: resolvers.getComponentValues(caseState, uiEngineProps, 'IntegrityStatus').valueItem,
  integrityScore: resolvers.getComponentValues(caseState, uiEngineProps, 'IntegrityScore').value
});

export interface IntegrityValuesShape {
  integrityStatus: ComplexValue<number>;
  integrityScore: ValueProperty;
  integrityStatusBarrierEval: ComplexValue<number>;  
}

export const integrityStatusBarrierEvalValues = (caseState, uiEngineProps) => ({
  integrityStatusBarrierEval: resolvers.getComponentValues(caseState, uiEngineProps, 'IntegrityStatusBarrierEva').valueItem  
});
